var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_41",
    "data-name": "Groupe 41",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15.02,
    height: 15.023,
    viewBox: "0 0 15.02 15.023",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_58",
    "data-name": "Rectangle 58",
    width: 15.02,
    height: 15.023,
    fill: "#0f0a53"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_33",
    "data-name": "Groupe 33",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_41",
    "data-name": "Trac\\xE9 41",
    d: "M7.543,14.827l4.2,4.2c-.036.038-.084.091-.134.141q-3.273,3.274-6.54,6.555a1.543,1.543,0,0,1-1.02.481c-1.1.1-2.2.235-3.306.361a.617.617,0,0,1-.738-.743q.205-1.791.4-3.583a.832.832,0,0,1,.242-.526q3.4-3.4,6.8-6.8c.034-.035.072-.065.1-.089",
    transform: "translate(0 -11.548)",
    fill: "#0f0a53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_42",
    "data-name": "Trac\\xE9 42",
    d: "M42.3,6.6,38.1,2.395c.03-.032.07-.077.113-.12q.841-.841,1.682-1.682a1.784,1.784,0,0,1,2.656,0q.777.774,1.55,1.551a1.787,1.787,0,0,1,0,2.657c-.6.6-1.2,1.2-1.8,1.8",
    transform: "translate(-29.669 0)",
    fill: "#0f0a53"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.6ca77258ec7c81880b6f1e7390aaf4fe.svg";
export { ForwardRef as ReactComponent };